export default __webpack_public_path__ + "static/media/status_live.fdcd3ee1.svg";